/**
 * Skeleton component
 * Shows placeholder content while loading
 */

interface SkeletonProps {
  className?: string;
  variant?: 'text' | 'circular' | 'rectangular';
}

/**
 * Base skeleton loader component
 * Use for creating loading placeholders
 *
 * @example
 * ```tsx
 * <Skeleton className="h-6 w-3/4" />
 * <Skeleton variant="circular" className="h-12 w-12" />
 * ```
 */
export function Skeleton({
  className = '',
  variant = 'rectangular',
}: SkeletonProps) {
  const variantClasses = {
    text: 'h-4 rounded',
    circular: 'rounded-full',
    rectangular: 'rounded-md',
  };

  return (
    <div
      className={`animate-pulse bg-gray-200 ${variantClasses[variant]} ${className}`}
      role="status"
      aria-label="Loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
}
